import { useQuery } from "@tanstack/react-query"

import codeValueApi from "./codeValueApi"

const useServiceToUseQuery = () => {
  const key = "codeValueApi.getServiceToUse"
  const { data = [] } = useQuery([key], codeValueApi.getServiceToUse, {
    select: (result) => (result.isSuccess ? result.data : []),
  })

  return data
}

export default useServiceToUseQuery
